import { Input, useMask } from '@yes.technology/react-toolkit'
import { ActionButton, StatusClass } from 'types/shared'
import DataFieldActionButton from './DataFieldActionButton'

const cssClassToStatusClass: Record<string, StatusClass> = {
  'is-valid': 'valid',
  'is-invalid': 'error',
  '': 'default'
}

type Props = {
  id: string
  value?: string
  informational?: boolean
  required?: boolean
  onChange: (value: string) => void
  cssClass: string
  label: string
  helpText?: string
  explanationText?: string
  formatMask?: string
  disabled?: boolean
  actionButton?: ActionButton
}

function ActivityInputInteger({
  id,
  value,
  informational,
  required,
  onChange,
  cssClass,
  label,
  helpText,
  explanationText,
  formatMask,
  disabled,
  actionButton
}: Props) {
  const { applyMask } = useMask()

  const handleValue = (rawValue: string) => {
    const integerValue = rawValue.replace(/[^0-9]+/g, '')
    const formattedValue = formatMask
      ? applyMask(integerValue, formatMask)
      : integerValue

    onChange(formattedValue)
  }

  return (
    <Input
      id={id}
      required={required}
      informational={informational}
      value={value || ''}
      onChange={handleValue}
      label={label}
      placeholder={helpText || explanationText}
      aria-label={label}
      heightClass='regular'
      statusClass={informational ? undefined : cssClassToStatusClass[cssClass]}
      disabled={disabled}
      actionButton={
        actionButton ? (
          <DataFieldActionButton
            actionButton={actionButton}
            disabled={disabled}
          />
        ) : undefined
      }
    />
  )
}

export default ActivityInputInteger
